import { render, staticRenderFns } from "./EmailTeaserBox.vue?vue&type=template&id=083de600&scoped=true&"
import script from "./EmailTeaserBox.vue?vue&type=script&lang=js&"
export * from "./EmailTeaserBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailTeaserBox.vue?vue&type=style&index=0&id=083de600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083de600",
  null
  
)

export default component.exports